import React from 'react';
import { CheckCircle, X } from 'phosphor-react';

const itemBase =
  'p-4 px-5 pr-12 rounded-xl border-2 relative bg-[var(--card-bg)]';

const itemVariants = {
  correct: 'border-emerald-500 bg-emerald-500/10',
  incorrect: 'border-red-500 bg-red-500/10',
};

const correctAnswerBase = 'text-[15px] text-[var(--text-primary)] leading-relaxed';
const userAnswerBase = 'text-sm font-medium mt-2 leading-relaxed';
const userAnswerVariants = {
  correct: 'text-emerald-600 dark:text-emerald-400',
  incorrect: 'text-red-600 dark:text-red-400',
};

/**
 * Component to render a single pairing item
 */
export function PairingItem({ pair, userAnswerData, isCorrectPair, hasUserAnswer }) {
  const variant = isCorrectPair ? 'correct' : 'incorrect';
  const IconComponent = isCorrectPair ? CheckCircle : X;

  return (
    <div className={`${itemBase} ${itemVariants[variant]}`}>
      <div className={correctAnswerBase}>
        <strong className="font-semibold text-[var(--text-primary)] mr-2">Correct:</strong>
        <span className="font-medium">{pair.l}</span>
        <span className="mx-3">→</span>
        <span>{pair.r}</span>
      </div>
      <IconComponent
        size={20}
        weight="fill"
        className={`absolute top-4 right-5 shrink-0 ${variant === 'correct' ? 'text-emerald-500' : 'text-red-500'}`}
      />
      {hasUserAnswer ? (
        <div className={`${userAnswerBase} ${userAnswerVariants[variant]}`}>
          <strong className="font-semibold mr-2">Your answer:</strong>
          {pair.l} → {userAnswerData.rightText}
        </div>
      ) : (
        <div className={`${userAnswerBase} ${userAnswerVariants.incorrect}`}>
          <strong className="font-semibold mr-2">Your answer:</strong>
          {pair.l} → (No answer)
        </div>
      )}
    </div>
  );
}
